export default "__VITE_ASSET__DiTDGqu___"